import ExpiredCert from './ExpiredCert.vue';

export default ExpiredCert;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/expiredcert/index.ts